import {createSlice} from '@reduxjs/toolkit';
import {getExperimentsData} from './experiments-actions';
import {Experiment} from 'api/experiments/experiments.types';

export interface ExperimentsState {
    data: Experiment[];
    isLoading: boolean;
}

const initialState: ExperimentsState = {
    data: [],
    isLoading: false,
};

/**
 * Experiments reducer
 */
const experimentsSlice = createSlice({
    name: 'experiments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getExperimentsData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getExperimentsData.fulfilled, (state, {payload}) => {
                state.data = payload;
                state.isLoading = false;
            })
            .addCase(getExperimentsData.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default experimentsSlice.reducer;
